import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/illustrations/spoon.png'


const _hoisted_1 = { class: "_invite-employee _modal bg-white" }
const _hoisted_2 = { class: "_modal__content px-12 py-6 flex flex-col items-center justify-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Luca Education",
    title: "Luca Education",
    height: "60",
    width: "60"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "_modal__content__title text-neutral-700 font-semibold text-2xl mt-5" }, " Tạo lớp nhóm ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-center text-neutral-500 mt-2" }, " Bạn hãy điền tên lớp nhóm và ấn “Xác nhận” để tạo lớp nhóm. ", -1)
const _hoisted_6 = { class: "w-full mt-10" }
const _hoisted_7 = { class: "input-group flex items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "input-group__label text-neutral-400 font-semibold w-2/5 uppercase" }, " Tên lớp nhóm ", -1)
const _hoisted_9 = {
  key: 0,
  class: "input-group flex items-center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "w-2/5" }, null, -1)
const _hoisted_11 = { class: "mt-4 w-full" }
const _hoisted_12 = { class: "error text-sienna-600 text-sm w-full" }
const _hoisted_13 = { class: "_modal__footer px-12 py-6 bg-neutral-50 flex flex-nowrap items-center" }
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "Gõ tên lớp nhóm",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.group.name) = $event)),
            class: _normalizeClass(_ctx.errorMes['name'] ? 'input--error' : ''),
            onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["enter"]))
          }, null, 34), [
            [_vModelText, _ctx.group.name]
          ])
        ]),
        (_ctx.errorMes['name'])
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.errorMes['name']), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("button", {
        type: "button",
        class: "button-p text-center mr-3 bg-none shadow-none text-neutral-500 hover:text-neutral-700",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
      }, " Thoát "),
      _createElementVNode("button", {
        type: "button",
        class: "button-p text-center whitespace-nowrap",
        disabled: _ctx.inProgress,
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
      }, " Xác nhận ", 8, _hoisted_14)
    ])
  ]))
}